// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__pUx9c","project":"project__1oLkl","projectGrey":"projectGrey__20sKM","projectList":"projectList__1Nvf7","projectListFixed":"projectListFixed__1FDlc"};


//////////////////
// WEBPACK FOOTER
// ./components/project-list/styles.styl
// module id = ll5u
// module chunks = 0